import { Injectable } from "@angular/core";
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { Role, LocalStorageKey, UserInfoModel } from "../login";

@Injectable()
export class AuthSignedInGuardService implements CanActivate {
  constructor( private router: Router) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    // TODO: check user login
    const userInfo = this.checkUserInfoFromStorage();
    if (userInfo) {
        if (userInfo.roles.find(r => r === Role.Admin)) {
            this.router.navigateByUrl('admin');
            return false;
        }
        if (userInfo.roles.find(r => r === Role.Customer)) {
            this.router.navigateByUrl('customer');
            return false;
        }
    }
    return true;
  }

  private checkUserInfoFromStorage(): UserInfoModel {
    const storageUser = localStorage.getItem(LocalStorageKey.CurrentUser);
        if (storageUser || storageUser !== '') {
            return JSON.parse(storageUser) as UserInfoModel;
        }
        return null;
    }

}